import React, { useState } from 'react';
import axios from 'axios';
import { apiUrl } from '../config/api';
import { getUserCityLocation } from '../lib/location';

const ExchangeForm = ({ fetchUserId, fetchCardId, onDismiss }) => {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    const formData = {
      fullName: e.target.elements.fullName.value.trim(),
      phone: e.target.elements.phone.value.trim(),
      email: e.target.elements.email.value.trim(),
    };

    if (!formData.fullName) {
      setErrorMessage('Please enter your name.');
      return;
    }

    const payload = {
      user_id: fetchUserId,
      card_id: fetchCardId,
      full_name: formData.fullName,
      email: formData.email || null,
      phone: formData.phone || null,
      location: await getUserCityLocation({ timeoutMs: 5000 }),
    };

    setIsSubmitting(true);
    try {
      await axios.post(apiUrl('/api/contactExchange'), payload);

      e.target.reset();
      setShowSuccessMessage(true);
      setTimeout(() => {
        setShowSuccessMessage(false);
        setTimeout(() => onDismiss(), 500);
      }, 2000);
    } catch (error) {
      console.error('Failed to save contact exchange:', error);
      setErrorMessage('Failed to send. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full bg-white space-y-3 absolute bottom-0 rounded-t-xl py-5 px-5"
    >
      {showSuccessMessage && (
        <div className="bg-green-500 text-white p-2 rounded-md">
          Sent successfully!
        </div>
      )}
      {errorMessage && (
        <div className="bg-red-500 text-white p-2 rounded-md">{errorMessage}</div>
      )}
      <p className="text-black font-bold sm:text-lg">
        Share your contact information...
      </p>
      <div className="flex flex-col">
        <label htmlFor="fullName">Full name *</label>
        <input
          type="text"
          name="fullName"
          required
          disabled={isSubmitting}
          className="rounded-md border-2 py-1 px-1 border-neutral-500"
          id="fullName"
        />
      </div>
      <div className="flex flex-col">
        <label htmlFor="phone">Phone</label>
        <input
          type="tel"
          name="phone"
          disabled={isSubmitting}
          className="rounded-md border-2 py-1 px-1 border-neutral-500"
          id="phone"
        />
      </div>
      <div className="flex flex-col">
        <label htmlFor="email">Email</label>
        <input
          type="email"
          name="email"
          disabled={isSubmitting}
          className="rounded-md border-2 py-1 px-1 border-neutral-500"
          id="email"
        />
      </div>
      <button
        type="submit"
        disabled={isSubmitting}
        className="block bg-black w-full py-3 text-white rounded-md disabled:opacity-60"
      >
        {isSubmitting ? 'Sending...' : 'Send'}
      </button>
    </form>
  );
};

export default ExchangeForm;
